const socialFeedConfig = Object.freeze({
  FacebookAppId: '324912232382618',
  InstagramFeedURL: 'https://graph.instagram.com/me/media?',
  InstagramFeedFields: 'fields=permalink',
  FeedLimit: '5',
  InstagramFeedAccessToken: '',
});

export default socialFeedConfig;
